module.exports = __webpack_public_path__ + "prod/1.42.2/img/success_exam1.2f2f541c.png";